<template>
  <div>
    <table width="1047" border="0" cellspacing="0" cellpadding="0" v-if="document()">
      <tr style="height: 1px">
          <td width="4"/>
          <td width="4"/>
          <td width="19"/>
          <td width="26"/>
          <td width="4"/>
          <td width="8"/>
          <td width="8"/>
          <td width="15"/>
          <td width="94"/>
          <td width="23"/>
          <td width="68"/>
          <td width="8"/>
          <td width="15"/>
          <td width="45"/>
          <td width="94"/>
          <td width="30"/>
          <td width="11"/>
          <td width="64"/>
          <td width="15"/>
          <td width="53"/>
          <td width="68"/>
          <td width="11"/>
          <td width="23"/>
          <td width="4"/>
          <td width="4"/>
          <td width="8"/>
          <td width="30"/>
          <td width="4"/>
          <td width="15"/>
          <td width="26"/>
          <td width="30"/>
          <td width="53"/>
          <td width="4"/>
          <td width="57"/>
          <td width="98"/>
          <td width="4"/>
      </tr>
      <tr style="height:59px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
          <td colspan="12" class="s0">Приложение к приказу Министра финансов<br>Республики Казахстан от 27 октября 2014 года № 458<br>Приложение 50 к приказу Министра финансов<br>Республики Казахстан от 20 декабря 2012 года № 562<br>Форма Р-1</td>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
          <td colspan="8" class="s0" style="font-size:1px">&nbsp;</td><td colspan="4" rowspan="4" class="s1">ИИН/БИН</td>
      </tr>
      <tr style="height:3px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td/><td/><td/><td/><td colspan="25" rowspan="3" class="s3">{{ document().contragent.contragent_prefix }} {{ document().contragent.name }}, {{ document().contract.address }}</td>
      </tr>
      <tr style="height:4px">
          <td colspan="6" rowspan="2" class="s6">Заказчик</td><td/>
      </tr>
      <tr style="height:22px">
          <td/><td colspan="4" class="s2">{{ document().contragent.identifier }}</td>
      </tr>
      <tr style="height:18px">
          <td colspan="32" class="s4">полное наименование, адрес, данные о средствах связи</td><td/><td/><td/><td/>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
          <td colspan="4" rowspan="2" class="s5">031040000631</td>
      </tr>
      <tr style="height:15px">
          <td colspan="7" class="s9">Исполнитель</td>
          <td colspan="25" class="s10">ТОО &quot;BTcom infocommunications&quot; 050059, Республика Казахстан, г. Алматы, пр. Аль-Фараби, д. 5</td>
      </tr>
      <tr style="height:14px">
          <td colspan="32" class="s4">полное наименование, адрес, данные о средствах связи</td><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td colspan="26" class="s4" style="font-size:1px">&nbsp;</td><td colspan="4" rowspan="4" class="s8">Номер<br>документа</td><td colspan="3" rowspan="4" class="s20">Дата<br>составления</td><td/><td/><td/>
      </tr>
      <tr style="height:15px">
          <td colspan="25" class="s6">Договор (контракт) № {{ document().contract.contract_num }} от {{ document().contract.contract_date }} </td><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td colspan="20" rowspan="2" class="title">АКТ ВЫПОЛНЕННЫХ РАБОТ (ОКАЗАННЫХ УСЛУГ)*</td><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:15px">
          <td/><td/><td/><td/><td/><td/><td colspan="4" class="s21">{{ document().number }}</td><td colspan="3" class="s22">{{ document().doc_date }}</td><td/><td/><td/>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:26px">
          <td colspan="3" rowspan="2" class="s8">Номер<br>по порядку</td>
          <td colspan="10" rowspan="2" class="s20">Наименование работ (услуг)<br>(в разрезе их подвидов в соответствии с технической спецификацией, заданием, графиком выполнения работ (услуг) при их наличии)</td>
          <td colspan="2" rowspan="2" class="s20">Дата выполнения работ<br>(оказания услуг)**</td>
          <td colspan="6" rowspan="2" class="s20">Сведения об отчете о научных исследованиях, маркетинговых, консультационных и прочих услугах (дата, номер, количество страниц) (при их наличии)***</td>
          <td colspan="5" rowspan="2" class="s20">Единица измерения</td>
          <td colspan="9" class="s20">Выполнено работ (оказано услуг)</td>
      </tr>
      <tr style="height:29px">
          <td colspan="4" class="s23">количество</td><td colspan="3" class="s23">цена за единицу</td><td colspan="2" class="s23">Стоимость</td>
      </tr>
      <tr style="height:15px">
          <td colspan="3" class="s24">1</td><td colspan="10" class="s23">2</td><td colspan="2" class="s23">3</td><td colspan="6" class="s23">4</td><td colspan="5" class="s23">5</td><td colspan="4" class="s23">6</td><td colspan="3" class="s23">7</td><td colspan="2" class="s23">8</td>
      </tr>
      <template v-if="$store.state.current_document_content">
        <tr style="height:15px" v-for="(item, index) in $store.state.current_document_content" :key="index">
            <td colspan="3" class="s24">{{ index + 1 }}</td>
            <td colspan="10" class="s25">{{ item.service_name }}</td>
            <td colspan="2" class="s23"></td>
            <td colspan="6" class="s23" style="font-size:1px">&nbsp;</td>
            <td colspan="5" class="s23">{{ item.measure }}</td>
            <td colspan="4" class="s23">{{ item.quantity }}</td>
            <td colspan="3" class="s26">{{ item.price }}</td>
            <td colspan="2" class="s26">{{ item.final_amount }}</td>
        </tr>
      </template>
      <tr style="height:15px">
          <td colspan="21"></td>
          <td colspan="5" class="s14">Итого</td>
          <td colspan="4" class="s23">{{ total_quantity() }}</td>
          <td colspan="3" class="s27" style="font-size:1px">&nbsp;</td><td colspan="2" class="s26">{{ total_amount() }}</td>
      </tr>
      <tr style="height:7px">
          <td colspan="21"/>
      </tr>
      <tr style="height:9px">
          <td colspan="36" rowspan="2" class="s16">Сведения об использовании запасов, полученных от заказчика___________________________________________________________________________________________________________________________________________</td>
      </tr>
      <tr style="height:2px">

      </tr>
      <tr style="height:7px">
          <td colspan="12" class="s16" style="font-size:1px">&nbsp;</td><td colspan="23" rowspan="3" class="s4">полное наименование, адрес, данные о средствах связи</td><td class="s16" style="font-size:1px">&nbsp;</td>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td rowspan="2" class="s13" style="font-size:1px"></td><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td/><td colspan="6" class="s13" style="font-size:1px"></td><td/><td/>
      </tr>
      <tr style="height:15px">
          <td colspan="36" class="s16">Приложение: Перечень документации, в том числе отчет(ы) о маркетинговых, научных исследованиях, консультационных и прочих услугах (обязательны при его (их) наличии) на ________________ страниц ________________</td>
      </tr>
      <tr style="height:4px">
          <td colspan="15" rowspan="3" class="s17">Уполномоченный на подписание актов выполненных работ за главного бухгалтера<br>согласно доверенности №24-22 от 01.11.2022г.</td><td colspan="21" class="s16" style="font-size:1px">&nbsp;</td>
      </tr>
      <tr style="height:18px">
          <td colspan="2" rowspan="4" class="s13" style="font-size:1px">&nbsp;</td><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td colspan="17" rowspan="3" class="s16">Принял (Заказчик)     _________________________ / _____________________ / ______________________</td>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td colspan="6" class="s13" style="font-size:1px">&nbsp;</td><td/><td colspan="4" class="s13" style="font-size:1px">&nbsp;</td><td/><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td/><td colspan="4" class="s13" style="font-size:1px">&nbsp;</td><td colspan="5" rowspan="2" class="s4">Главный менеджер по услугам связи</td><td colspan="2" class="s13" style="font-size:1px">&nbsp;</td><td/><td/>
      </tr>
      <tr style="height:11px">
          <td/><td colspan="7" rowspan="2" class="s16">Сдал (Исполнитель) _____________________________________________ / _____________________ / Смагулова А.А.</td><td colspan="5" rowspan="2" class="s16" style="font-size:1px">&nbsp;</td><td/><td colspan="17" rowspan="2" class="s18">                                                должность                                   подпись                      расшифровка подписи</td>
      </tr>
      <tr style="height:4px">
          <td/><td colspan="5" class="s16" style="font-size:1px">&nbsp;</td><td/>
      </tr>
      <tr style="height:11px">
          <td/><td/><td colspan="16" rowspan="2" class="s18">                                                              должность                                                        подпись                   расшифровка подписи</td><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:4px">
          <td/><td/><td/><td colspan="9" rowspan="2" class="s16">Дата подписания (принятия) работ (услуг) </td><td/><td colspan="3" rowspan="2" class="s19">{{ document().doc_date }}</td><td/><td/><td/><td/>
      </tr>
      <tr style="height:11px">
          <td/><td/><td/><td/><td colspan="6" class="s13" style="font-size:1px">&nbsp;</td><td/><td colspan="6" rowspan="5" class="s13" style="font-size:1px">&nbsp;</td><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td colspan="6" rowspan="2" class="s4">М.П.</td><td rowspan="4" class="s13" style="font-size:1px">&nbsp;</td><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:11px">
          <td/><td/><td/><td/><td/><td/><td colspan="4" rowspan="2" class="s4">М.П.</td><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td colspan="5" rowspan="2" class="s13" style="font-size:1px">&nbsp;</td><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:7px">
          <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:2px">
          <td colspan="36" rowspan="3" class="s16">* Применяется для приемки-передачи выполненных работ (оказанных услуг), за исключением строительно-монтажных работ.<br>** Заполняется в случае, если даты выполненных работ (оказанных услуг) приходятся на различные периоды, а также в случае, если даты выполнения работ (оказанных услуг) и даты подписания (принятия) работ (услуг) различны.<br>*** Заполняется в случае наличия отчета о научных исследованиях, маркетинговых, консультационных и прочих услугах</td>
      </tr>
      <tr style="height:9px">
      </tr>
      <tr style="height:25px">
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "CertOfCompletionPrint",
  props: {
    document_data: null
  },
  methods:{
    currentDate: function (){
      const current = new Date();
      // const output = `${current.getDate()}.${current.getMonth()}.${current.getFullYear()} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
      const output = current.toLocaleString();
      return output;
    },
    document: function (){
      return this.$store.state.current_document ? this.$store.state.current_document : null
    },
    document_content: function (){
      return this.$store.state.current_document_content ? this.$store.state.current_document_content : null
    },
    total_amount(){
      const init = 0
      let tot = 0
      if (this.document_content()){
         tot = this.document_content().reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.final_amount), init
        )
      }
      return tot
    },
    total_quantity(){
      const init = 0
      let tot = 0
      if (this.document_content()){
         tot = this.document_content().reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.quantity), init
        )
      }
      return tot
    },
  },
}
</script>

<style scoped>

.page_break {page-break-before: always;}
.s0 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Right; vertical-align: Top;
    padding-top: 1px;
    padding-right: 2px;
}
.s1 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    text-align: Center; vertical-align: Bottom;
    padding-bottom: 1px;
}
.s2 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s3 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-width: 0px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Left; vertical-align: Bottom;
    padding-bottom: 1px;
    padding-left: 2px;
}
.s4 {
    font-family: Times New Roman;
    font-size: 9px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Center; vertical-align: Top;
    padding-top: 1px;
}
.s5 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s6 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Left; vertical-align: Middle;
    padding-left: 2px;
}
.title {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    text-align: Right; vertical-align: Middle;
    padding-right: 2px;
}
.s8 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s9 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s10 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-width: 0px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s11 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Left; vertical-align: Middle;
    padding-left: 2px;
}
.s12 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Right; vertical-align: Middle;
    padding-right: 2px;
}
.s13 {
    font-family: Arial;
    font-size: 13px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
}
.s14 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    text-align: Right; vertical-align: Middle;
    padding-right: 2px;
}
.s15 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s16 {
    font-family: Times New Roman;
    font-size: 9px;
    color: #000000; font-style: normal;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s17 {
    font-family: Times New Roman;
    font-size: 9px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s18 {
    font-family: Times New Roman;
    font-size: 9px;
    color: #000000; font-style: italic;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s19 {
    font-family: Times New Roman;
    font-size: 9px;
    color: #000000; font-style: normal; text-decoration: underline;
    background-color: transparent;
    text-align: Left; vertical-align: Top;
    padding-top: 1px;
    padding-left: 2px;
}
.s20 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s21 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s22 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-weight: bold; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s23 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s24 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.s25 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Left; vertical-align: Middle;
    padding-left: 2px;
}
.s26 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Right; vertical-align: Middle;
    padding-right: 2px;
}
.s27 {
    font-family: Times New Roman;
    font-size: 11px;
    color: #000000; font-style: normal;
    background-color: transparent;
    border-left-width: 0px;
    border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
    border-top-width: 0px;
    border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
    text-align: Center; vertical-align: Middle;
}
.page {
	background-color: white;
	border-color: black;
	border-style: solid;
	border-width: 1px;
	width: 1050;
	margin-left: auto;
	margin-right: auto;
	padding: 20px;
	box-shadow: 5px 5px gray;
}
P {margin: 0;}

</style>